// extracted by mini-css-extract-plugin
export var typingIndicator = "_s5-0";